<script>
  import { onMount } from "svelte";
  import Chart from "chart.js";

  export let records = [];

  let chartInstance = null;

  // Prepare data for the bar chart
  $: barChartData = (() => {
    if (!records || records.length === 0) {
      return { labels: [], datasets: [] };
    }

    // Group by piloto and sum total_peso
    const pilotoTotals = {};
    records.forEach(record => {
      if (record.nombre) {
        pilotoTotals[record.nombre] = (pilotoTotals[record.nombre] || 0) + (record.total_peso || 0);
      }
    });

    // Sort by total peso and take top 8
    const sortedPilotos = Object.entries(pilotoTotals)
      .sort(([,a], [,b]) => b - a)
      .slice(0, 8);

    const labels = sortedPilotos.map(([piloto]) => piloto);
    const values = sortedPilotos.map(([, total]) => total);

    return {
      labels,
      datasets: [{
        label: 'Total Peso por Piloto',
        backgroundColor: '#ed64a6',
        borderColor: '#ed64a6',
        data: values,
        fill: false,
        barThickness: 8
      }]
    };
  })();

  onMount(async () => {
    const ctx = document.getElementById("piloto-peso-bar-chart");
    if (!ctx) return;

    const config = {
      type: "bar",
      data: {
        labels: barChartData.labels || [],
        datasets: barChartData.datasets || [{
          label: 'Total Peso por Piloto',
          backgroundColor: '#ed64a6',
          borderColor: '#ed64a6',
          data: [],
          fill: false,
          barThickness: 8
        }]
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: false,
          text: "Rendimiento de Pilotos",
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function(context) {
              const label = context.dataset && context.dataset.label ? context.dataset.label : '';
              const value = context.parsed && context.parsed.y != null ? context.parsed.y.toLocaleString() : '';
              return label ? `${label}: ${value} lbs` : `${value} lbs`;
            }
          }
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        legend: {
          labels: {
            fontColor: "rgba(0,0,0,.4)",
          },
          align: "end",
          position: "bottom",
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Piloto",
              },
              ticks: {
                maxRotation: 45,
                minRotation: 0,
                fontColor: "rgba(0,0,0,.4)",
                fontSize: 10
              },
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.3)",
                zeroLineColor: "rgba(33, 37, 41, 0.3)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Peso (lbs)",
              },
                              ticks: {
                  callback: function(value) {
                    return value.toLocaleString() + ' lbs';
                  }
                },
              gridLines: {
                borderDash: [2],
                drawBorder: false,
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.2)",
                zeroLineColor: "rgba(33, 37, 41, 0.15)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
        },
      },
    };

    chartInstance = new Chart(ctx, config);
  });

  // Update chart when data changes
  $: if (chartInstance && barChartData) {
    chartInstance.data.labels = barChartData.labels || [];
    chartInstance.data.datasets = barChartData.datasets || [];
    chartInstance.update();
  }
</script>

<div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
  <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full max-w-full flex-grow flex-1">
        <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
          Rendimiento
        </h6>
        <h2 class="text-blueGray-700 text-xl font-semibold">
          Top Pilotos por Peso
        </h2>
      </div>
    </div>
  </div>
  <div class="p-4 flex-auto">
    <div class="relative h-350-px">
      <canvas id="piloto-peso-bar-chart"></canvas>
    </div>
  </div>
</div> 